import Button from '../../components/ui/button/Button'
import { Kanban, List } from 'lucide-react'
import { useBusiness } from '../../context/BusinessContext'

const BusinessModeView = () => {
    const { mode, setMode } = useBusiness()

    return (
        <Button size='sm' variant='outline' onClick={() => setMode(mode === 'pipeline' ? 'list' : 'pipeline')}>
            {mode === 'list' ? <Kanban className='w-4 h-4' /> : <List className='w-4 h-4' />}
            {mode === 'list' ? 'Pipeline' : 'Lista'}
        </Button>
    )
}

export default BusinessModeView
